import { rest } from 'msw'
import {
  LedgerWalletTransaction,
  LedgerWalletTransactionsResponse,
} from 'types/ledger/ledgerWalletTransactions'
import mockRewardsTransactions from '../../../__mocks__/Transactions/rewardsTransactions.json'

export const getRewardsTransactions = rest.get<LedgerWalletTransactionsResponse>(
  `${process.env.API_URL}/ledger/v1/transactions`,
  async (req, res, ctx) => {
    const typeParam = req.url.searchParams.get('type')
    const walletIdParam = req.url.searchParams.get('walletId')
    const hasTypeParam = !!typeParam

    // Get pagination parameters from query string (API uses 'page' and 'size')
    const page = Number.parseInt(req.url.searchParams.get('page') || '0', 10)
    const size = Number.parseInt(req.url.searchParams.get('size') || '10', 10)

    // Calculate pagination
    const allTransactions = mockRewardsTransactions.content.filter(tx => {
      if (hasTypeParam) {
        return true
      }
      return tx.walletId === walletIdParam
    })
    const totalElements = allTransactions.length
    const totalPages = Math.ceil(totalElements / size)
    const startIndex = page * size
    const endIndex = Math.min(startIndex + size, totalElements)
    const paginatedContent = allTransactions.slice(startIndex, endIndex)

    // Build paginated response
    const paginatedResponse: LedgerWalletTransactionsResponse = {
      content: paginatedContent as unknown as LedgerWalletTransaction[],
      pageable: {
        sort: {
          sorted: false,
          unsorted: true,
          empty: true,
        },
        pageNumber: page,
        pageSize: size,
        offset: startIndex,
        paged: true,
        unpaged: false,
      },
      last: page >= totalPages - 1,
      totalElements,
      totalPages,
      first: page === 0,
      size,
      number: page,
      sort: {
        sorted: false,
        unsorted: true,
        empty: true,
      },
      numberOfElements: paginatedContent.length,
      empty: paginatedContent.length === 0,
    }

    return res(ctx.json(paginatedResponse))
  }
)

export default [getRewardsTransactions]
